import api from "utils/api";

// Create a new tutor leader board entry
export const createTutorLeaderBoard = async (data) => {
  try {
    const response = await api.post("/tutor-leader-board", data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get all tutor leader board entries
export const getTutorLeaderBoards = async (params = {}) => {
  try {
    const response = await api.get("/tutor-leader-board", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get tutor leader board by ID
export const getTutorLeaderBoardById = async (id) => {
  try {
    const response = await api.get(`/tutor-leader-board?id=${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get tutor leader board by month and year
export const getTutorLeaderBoardByMonthYear = async (month, year) => {
  try {
    const response = await api.get("/tutor-leader-board", {
      params: { month, year },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
